import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { getUrlParam } from 'core-components/helpers/url'
import { P360_PAGE_URL } from 'partner360/configs'
import { selectFinancialCockpitDownload } from 'partner360/features/financialCockpit'
import { useViewModeFromUrl } from 'partner360/hooks/useViewModeFromUrl'

export const useIsCockpitContentBlocked = () => {
  const { pathname } = useLocation()
  const viewMode = useViewModeFromUrl()
  const { status } = useSelector(selectFinancialCockpitDownload)

  return (
    viewMode === 'new' &&
    getUrlParam('page', pathname) === P360_PAGE_URL &&
    status !== 'idle' &&
    status !== 'cancelled'
  )
}
